/**
 * Mock game data used when REACT_APP_GAS_URL is not configured.
 * Represents what real data looks like so the UI is fully exercised.
 */

const now = Date.now();
const h = (hours) => new Date(now + hours * 3600 * 1000).toISOString();

export const MOCK_GAMES = [
  {
    id: 'mock_epic_1',
    title: 'Alan Wake 2',
    platform: 'epic',
    type: 'free-to-keep',
    thumbnail: 'https://cdn1.epicgames.com/offer/738b08189d504d47b8f64c1e8f9e8aac/EGS_AlanWake2_RemedyEntertainment_S1_2560x1440-4e0f2f19e11e45a97f13a21dc38d0748',
    claimUrl: 'https://store.epicgames.com/en-US/p/alan-wake-2',
    availableFrom: h(-48),
    availableUntil: h(36),
    originalPrice: '$59.99',
  },
  {
    id: 'mock_epic_2',
    title: 'Horizon Zero Dawn Remastered',
    platform: 'epic',
    type: 'free-to-keep',
    thumbnail: 'https://cdn1.epicgames.com/offer/b9aca130abb64b18b1bb2a04c41ea899/EGS_HorizonZeroDawnRemastered_GuerrillaGames_S1_2560x1440-0da22eb1b3e18ef89fe8de44e7d9e9d9',
    claimUrl: 'https://store.epicgames.com/en-US/p/horizon-zero-dawn-remastered',
    availableFrom: h(-24),
    availableUntil: h(18),
    originalPrice: '$49.99',
  },
  {
    id: 'mock_steam_special_1',
    title: 'Deponia',
    platform: 'steam',
    type: 'free-to-keep',
    thumbnail: 'https://cdn.akamai.steamstatic.com/steam/apps/214340/header.jpg',
    claimUrl: 'https://store.steampowered.com/app/214340',
    availableFrom: h(-24),
    availableUntil: null,
    originalPrice: '$29.99',
  },
  {
    id: 'mock_steam_1',
    title: 'Dota 2',
    platform: 'steam',
    type: 'permanently-free',
    thumbnail: 'https://cdn.cloudflare.steamstatic.com/steam/apps/570/header.jpg',
    claimUrl: 'https://store.steampowered.com/app/570/Dota_2/',
    availableFrom: null,
    availableUntil: null,
    originalPrice: null,
  },
  {
    id: 'mock_steam_2',
    title: 'Destiny 2',
    platform: 'steam',
    type: 'permanently-free',
    thumbnail: 'https://cdn.cloudflare.steamstatic.com/steam/apps/1085660/header.jpg',
    claimUrl: 'https://store.steampowered.com/app/1085660/Destiny_2/',
    availableFrom: null,
    availableUntil: null,
    originalPrice: null,
  },
  {
    id: 'mock_steam_3',
    title: 'Hogwarts Legacy Free Weekend',
    platform: 'steam',
    type: 'free-weekend',
    thumbnail: 'https://cdn.cloudflare.steamstatic.com/steam/apps/990080/header.jpg',
    claimUrl: 'https://store.steampowered.com/app/990080/',
    availableFrom: h(-12),
    availableUntil: h(20),
    originalPrice: '$59.99',
  },
  {
    id: 'mock_gog_1',
    title: 'Cyberpunk 2077',
    platform: 'gog',
    type: 'free-to-keep',
    thumbnail: 'https://images.gog-statics.com/5643a7c831df452d29005caeca24c28cdbfaa6fbea5a3eef8e9fa78b78f4f2f6_product_card_v2_mobile_slider_639.jpg',
    claimUrl: 'https://www.gog.com/en/game/cyberpunk_2077',
    availableFrom: h(-6),
    availableUntil: h(66),
    originalPrice: '$39.99',
  },
  {
    id: 'mock_itchio_1',
    title: 'Celeste Classic',
    platform: 'itchio',
    type: 'free-to-keep',
    thumbnail: 'https://img.itch.zone/aW1nLzI0MzI3NzUucG5n/315x250%23c/Fo0JmK.png',
    claimUrl: 'https://maddythorson.itch.io/celeste',
    availableFrom: null,
    availableUntil: null,
    originalPrice: null,
  },
  {
    id: 'mock_itchio_2',
    title: 'A Short Hike',
    platform: 'itchio',
    type: 'free-to-keep',
    thumbnail: 'https://img.itch.zone/aW1nLzE4NDI3MTYucG5n/315x250%23c/kv0RBB.png',
    claimUrl: 'https://adamgryu.itch.io/a-short-hike',
    availableFrom: null,
    availableUntil: h(72),
    originalPrice: '$7.99',
  },
];
